import { Button, Col, InputNumber, Row, Switch } from 'antd';
import React, { useMemo, useState } from 'react';
import { CheckOutlined } from '@ant-design/icons';
import { formatCurrency } from '~/utils/currency';

const cashRange = [
  2000, 5000, 10000, 15000, 20000, 30000, 50000, 70000, 100000, 120000,
];

const CashTab = ({
  isRounding,
  setIsRounding,
  totalPrice,
  onSubmit,
  disableRounding,
}: {
  isRounding: boolean;
  setIsRounding: (val: boolean) => void;
  totalPrice: number;
  onSubmit: (amount: number) => void;
  disableRounding?: boolean;
}) => {
  const [value, setValue] = useState<any>(null);
  const cashOptions = useMemo(() => {
    if (totalPrice < cashRange[0]) return cashRange.slice(0, 2);
    if (totalPrice < cashRange[cashRange.length - 1]) {
      const options = [];
      for (let i = 0; i < cashRange.length - 1; i++) {
        if (cashRange[i] >= totalPrice) {
          options.push(...cashRange.slice(i, i + 2));
          break;
        }
      }
      if (options.length < 2) {
        options.push(Math.ceil(totalPrice / 50000) * 50000);
      }
      return options;
    } else {
      const div = Math.ceil(totalPrice / 50000);
      return [div * 50000, (div + 1) * 50000];
    }
  }, [totalPrice]);

  return (
    <div>
      {!disableRounding && (
        <div className="flex gap-3 items-center mb-6">
          <Switch checked={isRounding} onChange={(val) => setIsRounding(val)} />
          <p className="text-lg mb-0">Rounding</p>
        </div>
      )}
      <Row gutter={[8, 8]}>
        <Col span={12}>
          <Button onClick={() => onSubmit(totalPrice)} size="large" block>
            Uang Pas
          </Button>
        </Col>
        {cashOptions.map((val) => (
          <Col span={12} key={val}>
            <Button onClick={() => onSubmit(val)} size="large" block>
              {formatCurrency(val)}
            </Button>
          </Col>
        ))}
        <Col span={12}>
          <InputNumber
            size="large"
            width={'100%'}
            value={value}
            onChange={(val) => setValue(val)}
            addonAfter={<CheckOutlined onClick={() => onSubmit(value)} />}
            placeholder="Nominal"
            className="w-full"
          />
        </Col>
      </Row>
    </div>
  );
};

export default CashTab;
